<template>
  <div class="war-room-topics">
    <div class="war-room-topics__header">
      <div data-test="topics_title" class="war-room-topics__title">Popular Topics</div>
    </div>
    <div class="war-room-topics__content">
      <WarRoomTopic
        v-for="topic in topics"
        :key="topic.id"
        :topic="topic"
        data-test="topics_topic"
        class="war-room-topics__tag"
        @click.native="sendAnalyticEvent(topic.name)"
      />
    </div>
    <div class="war-room-topics__footer">
      <BravadoButtonV3 variant="blank" size="sm" :to="topicsListModalRoute" data-test="see_all_topics">
        See all topics
      </BravadoButtonV3>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import type { PropOptions } from 'vue';
import type { IPostTopic } from '@/types/community';
import WarRoomTopic from '@/components/partials/war-room/WarRoomTopic/WarRoomTopic.vue';
import { modalNames } from '~/components/partials/war-room/constants';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';

export default Vue.extend({
  name: 'WarRoomTopics',
  components: {
    WarRoomTopic,
    BravadoButtonV3,
  },
  props: {
    topics: {
      type: Array,
      required: true,
    } as PropOptions<Array<IPostTopic>>,
  },
  computed: {
    topicsListModalRoute(): Record<string, Record<string, string>> {
      return { query: { dynamic_modal: modalNames.TOPICS_LIST } };
    },
  },
  methods: {
    sendAnalyticEvent(topicName: string) {
      this.$analytics.logEvent('war-room__topics__click', {
        topicName,
      });
    },
  },
});
</script>

<style scoped lang="scss">
.war-room-topics {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: var(--theme-elevation-01);

  &__header {
    padding: 8px;
    background: var(--theme-color-over-card);
  }

  &__title {
    text-align: center;
    font-weight: 600;
    font-size: 13px;
    line-height: 1.54;
    color: var(--gray-50);
  }

  &__content {
    padding: 12px 3px 3px 16px;
    background: var(--theme-color-card);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
  }

  &__footer {
    background: var(--theme-color-card);
    text-align: center;
    padding-bottom: 16px;
  }

  &__tag {
    margin: 0 13px 13px 0;
  }
}
</style>
